import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import FormDate from "../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../Media/DropButton';

class StructuresFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
        };
    }

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            machines,
            formUrl,
            isEdit,
            uploadConfig,
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >
                <input type="hidden" name="structure_id" value={values.structure_id} onChange={handleChange}/>
                <Grid container spacing={24} alignItems="center">
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            autoFocus={true}
                            name="structure_name"
                            label={i18n.get('structures.name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.structure_name}
                            error={errors.structure_name}
                            touched={touched.structure_name}
                            disabled={isEdit}
                            readOnly={isEdit}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="legal_regulation"
                            label={i18n.get('structures.legal_regulation')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.legal_regulation}
                            error={errors.legal_regulation}
                            touched={touched.legal_regulation}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {!isEdit &&
                        <FormSelect
                            name="machine_id"
                            label={i18n.get('structures.machine')}
                            error={errors.machine_id}
                            touched={touched.machine_id}
                            onChange={selectedOption =>
                                setFieldValue(
                                    "machine_id",
                                    selectedOption.value
                                )}
                            onBlur={handleBlur}
                            options={machines.map((value) => ({label: value.name, value: value.id, entity: value}))}
                            value={values.machine_id}
                        />
                        }
                        {isEdit &&
                        <FormField
                            type="text"
                            disabled
                            autoComplete={false}
                            name="machine_id"
                            label={i18n.get('structures.machine')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={machines.name}
                        />
                            }
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>

                        {/*{isEdit && (*/}
                        {/*    <DeleteButton*/}
                        {/*        href={`/persons/${values.id}`}*/}
                        {/*        confirmMessage={i18n.get('persons.confirm_message')}*/}
                        {/*        successMessage={i18n.get('persons.delete_success_message')}*/}
                        {/*        handleSuccess={() => {history.go(-1)}}*/}
                        {/*    />*/}
                        {/*)}*/}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('persons.update') : i18n.get('persons.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default StructuresFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Structures/StructuresFormFields.js